import _ from 'underscore';
import { useLocation } from 'react-router-dom';
import { LayoutContext, layoutConfigs, withLayout } from '@bingads-webui-react/app-layout-container';
import { useEffect, useContext } from 'react';


const LayoutSwitchInner = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const layout = params.get('layout');
  const { change } = useContext(LayoutContext);
  useEffect(() => {
    if (layout && layoutConfigs[layout]) {
      change(layoutConfigs[layout], undefined, undefined, _.noop, true);
    }
  }, [layout, change]);

  return null;
};

export const LayoutSwitch = withLayout(LayoutSwitchInner);
